'use client'

import { useHydration } from '@/hooks/use-hydration'
import ExportedImage from 'next-image-export-optimizer'

import { AssistCarousel } from '@/components/molecules/carousel/assist-carousel'
import Container from '@/components/templates/container/container'

interface Props {
  data: PMA
}

export const PMAAssit = ({ data }: Props) => {
  const isHydrated = useHydration()

  if (!isHydrated || data.items[0].fields.features === undefined) return null

  return (
    <section className="bg-white py-9 lg:py-16">
      <Container className="space-y-6 lg:space-y-14">
        <header className="flex flex-col items-center gap-1.5 lg:gap-5">
          <ExportedImage src="/easybiz-hoc.png" alt="" width={120} height={120} />
          <h2 className="text-2xl font-extrabold text-primary-blue lg:text-4xl">How Easybiz Assists You</h2>
        </header>

        <AssistCarousel data={data.items[0].fields.features} />
      </Container>
    </section>
  )
}
